module.exports = __webpack_public_path__ + "static/image2-3b0b7f2dee7e54b6ba521248a7eaf60e.png";